var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "Subheader",
                {
                  attrs: {
                    title: "Continuous Data Stations",
                    search: "continuous data stations",
                  },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "", color: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.clickAddStationLink()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.add_link")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.continuousDataStations,
                      pagination: _vm.pagination,
                      search: _vm.search,
                      "item-key": "name",
                    },
                    on: {
                      "update:pagination": function ($event) {
                        _vm.pagination = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function (props) {
                          return [
                            _c(
                              "tr",
                              {
                                staticClass: "pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.getStationParameters(props)
                                  },
                                },
                              },
                              [
                                _c("td", [_vm._v(_vm._s(props.item.name))]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-right" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          dark: "",
                                          color: "delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.clickUnlink(props.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { staticClass: "mr-1" }, [
                                          _vm._v("delete_forever"),
                                        ]),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("Button.unlink")) +
                                            "\n                "
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-icon", [
                                      _vm._v("keyboard_arrow_down"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "expand",
                        fn: function (props) {
                          return [
                            _c("v-progress-linear", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isRequesting,
                                  expression: "isRequesting",
                                },
                              ],
                              attrs: {
                                indeterminate: true,
                                color: "secondary",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "v-card",
                              {
                                staticClass: "backgroundColor",
                                attrs: { flat: "" },
                              },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-form",
                                      {
                                        ref: "form",
                                        staticStyle: { width: "100%" },
                                        attrs: { "lazy-validation": "" },
                                        model: {
                                          value: _vm.valid,
                                          callback: function ($$v) {
                                            _vm.valid = $$v
                                          },
                                          expression: "valid",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list",
                                          {
                                            staticStyle: { padding: "0px" },
                                            attrs: { "three-line": "" },
                                          },
                                          [
                                            _c(
                                              "v-list-tile",
                                              {
                                                staticClass: "backgroundColor",
                                              },
                                              [
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      color: "success",
                                                      small: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.addTagForAllDialog = true
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { staticClass: "mr-1" },
                                                      [_vm._v("add")]
                                                    ),
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Button.Add_tag_for_all"
                                                        )
                                                      ) +
                                                        "\n                      "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      color: "error",
                                                      small: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.removeTagForAllDialog = true
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { staticClass: "mr-1" },
                                                      [_vm._v("delete_forever")]
                                                    ),
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Button.REMOVETAGFORALL"
                                                        )
                                                      ) +
                                                        "\n                      "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile",
                                              {
                                                staticClass: "backgroundColor",
                                              },
                                              [
                                                _c(
                                                  "v-layout",
                                                  { attrs: { wrap: "" } },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          xs12: "",
                                                          sm12: "",
                                                          md12: "",
                                                          lg6: "",
                                                        },
                                                      },
                                                      [
                                                        _c("v-checkbox", {
                                                          staticStyle: {
                                                            "padding-top":
                                                              "10px",
                                                            float: "left",
                                                          },
                                                          attrs: {
                                                            color: "primary",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.checkedAll,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.checkedAll =
                                                                $$v
                                                            },
                                                            expression:
                                                              "checkedAll",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-subheader",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "16px",
                                                              "font-weight":
                                                                "bold",
                                                              float: "left",
                                                            },
                                                          },
                                                          [_vm._v("Select All")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          xs4: "",
                                                          sm4: "",
                                                          md4: "",
                                                          lg2: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-subheader",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "16px",
                                                              "font-weight":
                                                                "bold",
                                                              padding: "0px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Start Date:\n                          "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          xs4: "",
                                                          sm4: "",
                                                          md4: "",
                                                          lg2: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-subheader",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "16px",
                                                              "font-weight":
                                                                "bold",
                                                              padding: "0px",
                                                            },
                                                          },
                                                          [_vm._v("End Date:")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          xs4: "",
                                                          sm4: "",
                                                          md4: "",
                                                          lg2: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-subheader",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "16px",
                                                              "font-weight":
                                                                "bold",
                                                              padding: "0px",
                                                            },
                                                          },
                                                          [_vm._v("Tag:")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-divider", {
                                              attrs: { light: "" },
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.accessInfo,
                                              function (item, i) {
                                                return [
                                                  _c(
                                                    "v-list-tile",
                                                    {
                                                      key: i,
                                                      staticClass:
                                                        "backgroundColor",
                                                    },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        { attrs: { wrap: "" } },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "d-flex align-center justify-space-",
                                                              attrs: {
                                                                xs12: "",
                                                                sm12: "",
                                                                md12: "",
                                                                lg6: "",
                                                              },
                                                            },
                                                            [
                                                              _c("v-checkbox", {
                                                                staticStyle: {
                                                                  "flex-grow":
                                                                    "0!important",
                                                                },
                                                                attrs: {
                                                                  id: item.DataSetIdentifer,
                                                                  color: "info",
                                                                  "hide-details":
                                                                    "",
                                                                  label:
                                                                    item.DataSetIdentifer,
                                                                },
                                                                model: {
                                                                  value:
                                                                    item.Checked,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        item,
                                                                        "Checked",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "item.Checked",
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  staticStyle: {
                                                                    "flex-grow":
                                                                      "0!important",
                                                                  },
                                                                  attrs: {
                                                                    icon: "",
                                                                    flat: "",
                                                                    color:
                                                                      "secondary",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.copyText(
                                                                          item.DataSetIdentifer
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "content_copy"
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                xs4: "",
                                                                sm4: "",
                                                                md4: "",
                                                                lg2: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-menu",
                                                                {
                                                                  staticStyle: {
                                                                    "padding-right":
                                                                      "30px",
                                                                  },
                                                                  attrs: {
                                                                    lazy: "",
                                                                    "close-on-content-click": false,
                                                                    transition:
                                                                      "scale-transition",
                                                                    "offset-y":
                                                                      "",
                                                                    "full-width":
                                                                      "",
                                                                    "nudge-right": 35,
                                                                    "max-width":
                                                                      "290px",
                                                                    "min-width":
                                                                      "290px",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.startMenu,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "startMenu",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.startMenu",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      attrs: {
                                                                        slot: "activator",
                                                                        "prepend-icon":
                                                                          "event",
                                                                        readonly:
                                                                          "",
                                                                      },
                                                                      slot: "activator",
                                                                      model: {
                                                                        value:
                                                                          item.FirstRecordDate,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item,
                                                                              "FirstRecordDate",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.FirstRecordDate",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-date-picker",
                                                                    {
                                                                      attrs: {
                                                                        "no-title":
                                                                          "",
                                                                        scrollable:
                                                                          "",
                                                                        actions:
                                                                          "",
                                                                        max: item.LastRecordDate,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item.FirstRecordDate,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item,
                                                                              "FirstRecordDate",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.FirstRecordDate",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                xs4: "",
                                                                sm4: "",
                                                                md4: "",
                                                                lg2: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-menu",
                                                                {
                                                                  staticStyle: {
                                                                    "padding-right":
                                                                      "30px",
                                                                  },
                                                                  attrs: {
                                                                    lazy: "",
                                                                    "close-on-content-click": false,
                                                                    transition:
                                                                      "scale-transition",
                                                                    "offset-y":
                                                                      "",
                                                                    "full-width":
                                                                      "",
                                                                    "nudge-right": 35,
                                                                    "max-width":
                                                                      "290px",
                                                                    "min-width":
                                                                      "290px",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.endMenu,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "endMenu",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.endMenu",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      attrs: {
                                                                        slot: "activator",
                                                                        "prepend-icon":
                                                                          "event",
                                                                        readonly:
                                                                          "",
                                                                      },
                                                                      slot: "activator",
                                                                      model: {
                                                                        value:
                                                                          item.LastRecordDate,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item,
                                                                              "LastRecordDate",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.LastRecordDate",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-date-picker",
                                                                    {
                                                                      attrs: {
                                                                        "no-title":
                                                                          "",
                                                                        scrollable:
                                                                          "",
                                                                        actions:
                                                                          "",
                                                                        min: item.FirstRecordDate,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item.LastRecordDate,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item,
                                                                              "LastRecordDate",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.LastRecordDate",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                xs4: "",
                                                                sm4: "",
                                                                md4: "",
                                                                lg2: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "ComboBoxWithSelectAll",
                                                                {
                                                                  attrs: {
                                                                    items:
                                                                      _vm.tagSelectList,
                                                                    elementMaxLength: 13,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.Tags,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "Tags",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.Tags",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.$vuetify.breakpoint
                                                    .mdAndDown
                                                    ? _c("v-divider", {
                                                        key: `tile-${i}`,
                                                      })
                                                    : _vm._e(),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-card-actions",
                                  [
                                    _c("v-spacer"),
                                    _vm._v(" "),
                                    _c("v-progress-circular", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isRequesting,
                                          expression: "isRequesting",
                                        },
                                      ],
                                      staticStyle: { "margin-right": "5px" },
                                      attrs: {
                                        indeterminate: true,
                                        color: "blue",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "success", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickSave()
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { staticClass: "mr-1" }, [
                                          _vm._v("done"),
                                        ]),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("Button.Save")) +
                                            "\n                "
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "secondary",
                                          small: "",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "removePadding",
                  attrs: { dense: "", color: "secondary", dark: "" },
                },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "AdministrationContinuousDataStations.addTitleMsg"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "pa-3": "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Station Name",
                              items: _vm.residueContinuousDataStations,
                              "item-text": "Name",
                              "item-value": "Name",
                            },
                            model: {
                              value: _vm.newStation,
                              callback: function ($$v) {
                                _vm.newStation = $$v
                              },
                              expression: "newStation",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.clickSaveNewStationLink()
                        },
                      },
                    },
                    [
                      _c("v-icon", [_vm._v("done")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Save")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800" },
          model: {
            value: _vm.comfirmDialog,
            callback: function ($$v) {
              _vm.comfirmDialog = $$v
            },
            expression: "comfirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "AdministrationContinuousDataStations.confirmTitleMsg",
                          { msg: _vm.unlinkStation.name }
                        )
                      ) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.comfirmDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "AdministrationContinuousDataStations.confirmTextMsg"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.agreeUnlinkStation()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("delete_forever"),
                      ]),
                      _vm._v(
                        _vm._s(_vm.$t("Button.UNLINK_STATION")) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.comfirmDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800px" },
          model: {
            value: _vm.addTagForAllDialog,
            callback: function ($$v) {
              _vm.addTagForAllDialog = $$v
            },
            expression: "addTagForAllDialog",
          },
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "removePadding",
                  attrs: { dense: "", color: "secondary", dark: "" },
                },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "AdministrationContinuousDataStations.addTagTitleMsg"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "pa-3": "" } },
                        [
                          _c(
                            "v-radio-group",
                            {
                              model: {
                                value: _vm.addTagToAllRadio,
                                callback: function ($$v) {
                                  _vm.addTagToAllRadio = $$v
                                },
                                expression: "addTagToAllRadio",
                              },
                            },
                            [
                              _c("v-radio", {
                                attrs: { value: "All", label: "All" },
                              }),
                              _vm._v(" "),
                              _c("v-radio", {
                                attrs: {
                                  value: "Only Assigned",
                                  label: "Only Assigned",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("ComboBoxWithSelectAll", {
                            attrs: {
                              items: _vm.tagSelectList,
                              label: "Tags",
                              maxLength: 10,
                            },
                            model: {
                              value: _vm.addToAllTagList,
                              callback: function ($$v) {
                                _vm.addToAllTagList = $$v
                              },
                              expression: "addToAllTagList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.AddTagToAll()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Add")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.addTagForAllDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800px" },
          model: {
            value: _vm.removeTagForAllDialog,
            callback: function ($$v) {
              _vm.removeTagForAllDialog = $$v
            },
            expression: "removeTagForAllDialog",
          },
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "removePadding",
                  attrs: { dense: "", color: "secondary", dark: "" },
                },
                [
                  _c("v-toolbar-title", [_vm._v("Remove Tag For All")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "pa-3": "" } },
                        [
                          _c("ComboBoxWithSelectAll", {
                            attrs: {
                              items: _vm.tagSelectList,
                              label: "Tags",
                              maxLength: 10,
                            },
                            model: {
                              value: _vm.removeToAllTagList,
                              callback: function ($$v) {
                                _vm.removeToAllTagList = $$v
                              },
                              expression: "removeToAllTagList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.RemoveTagToAll()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("delete_forever"),
                      ]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Remove")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.removeTagForAllDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")) + "\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }